import MoreVertIcon from "@material-ui/icons/MoreVert";
import * as React from "react";
import "./MoreActionButtonStyleSheet.css"

export default function MoreActionButton({children, inVisibleState = false}) {
    return (
        <section className={`${inVisibleState ? "d-none" : "title-action-container"}`}>
            <button className={"btn-secondary-action"}><MoreVertIcon
                fontSize="small"/></button>
            <section className="title-action-btn-container">
                {children}
            </section>
        </section>
    )
}